import { volunteerServiceClient } from './HTTPClient';
import {
	BooleanValue,
	FunctionaryOfZone,
	GetFunctionaryRequest,
	GetCandidatesRequest,
	GetCandidatesResponse,
	CreatePreworkGroupRequest,
	CreatePreworkGroupResponse,
	UpdatePreworkGroupRequest,
	UpdatePreworkGroupResponse,
	GetPreworkGroupRequest,
	AssignPreworkMentorRequest,
	PreworkGroup,
	CandidateGroupRequest,
	PreworkDashboardDetail,
	GetRegionsResponse,
	PreworkGraphicalViewResponse,
	GetBatchesRequest,
	GetBatchesResponse,
	GetRegionsRequest,
	GetZonesRequest,
	GetPreworkGroupResponse,
	GetPreworkCandidatesRequest,
	PreworkApplicationsRequest,
	PreworkApplicationsResponse,
	PreworkMentorAnswersRequest,
	PreworkRecommendationRequest,
} from '../shared/PreWorkServiceTypes';
import { GetZonesResponse } from '../shared/ExamModuleTypes';

export const assignPreworkMentor = async (
	request: AssignPreworkMentorRequest
): Promise<BooleanValue> => {
	const response = await volunteerServiceClient.post<BooleanValue>(
		'assignPreworkMentor',
		request
	);
	return response.data;
};

export const updatePreworkGroup = async (
	request: UpdatePreworkGroupRequest
): Promise<UpdatePreworkGroupResponse> => {
	const response =
		await volunteerServiceClient.post<UpdatePreworkGroupResponse>(
			'updatePreworkGroup',
			request
		);
	return response.data;
};

export const getBatches = async (
	request: GetBatchesRequest
): Promise<GetBatchesResponse> => {
	const response = await volunteerServiceClient.post<GetBatchesResponse>(
		'getBatches',
		request
	);
	return response.data;
};

export const createPreworkGroup = async (
	request: CreatePreworkGroupRequest
): Promise<CreatePreworkGroupResponse> => {
	const response =
		await volunteerServiceClient.post<CreatePreworkGroupResponse>(
			'createPreworkGroup',
			request
		);
	return response.data;
};

export const getPreworkDashboardMetrics = async (
	request: GetCandidatesRequest
): Promise<PreworkDashboardDetail> => {
	const response = await volunteerServiceClient.post<PreworkDashboardDetail>(
		'getPreworkDashboardMetrics',
		request
	);
	return response.data;
};

// getPreworkGroups newly added method
export const getPreworkGroups = async (
	request: GetPreworkGroupRequest
): Promise<GetPreworkGroupResponse> => {
	const response = await volunteerServiceClient.post<GetPreworkGroupResponse>(
		'getPreworkGroups',
		request
	);
	return response.data;
};

// getPreworkGroups newly added method
export const getPreworkGroup = async (
	request: GetPreworkGroupRequest
): Promise<PreworkGroup> => {
	const response = await volunteerServiceClient.post<PreworkGroup>(
		'getPreworkGroup',
		request
	);
	return response.data;
};

export const getPreworkCandidates = async (
	request: GetCandidatesRequest
): Promise<GetCandidatesResponse> => {
	const response = await volunteerServiceClient.post<GetCandidatesResponse>(
		'getPreworkCandidates',
		request
	);
	return response.data;
};

export const getPreworkGraphicalView = async (
	request: GetPreworkCandidatesRequest
): Promise<PreworkGraphicalViewResponse> => {
	const response =
		await volunteerServiceClient.post<PreworkGraphicalViewResponse>(
			'getPreworkGraphicalView',
			request
		);
	return response.data;
};

export const getCandidateGroup = async (
	request: CandidateGroupRequest
): Promise<PreworkGroup> => {
	const response = await volunteerServiceClient.post<PreworkGroup>(
		'getPreworkGroup',
		request
	);
	return response.data;
};

export const getRegionsOfLoggedInPreworkFunctionary = async (
	request: GetRegionsRequest
): Promise<GetRegionsResponse> => {
	const response = await volunteerServiceClient.post<GetRegionsResponse>(
		'getRegionsOfLoggedInPreworkFunctionary',
		request
	);
	return response.data;
};

export const getFunctionary = async (
	request: GetFunctionaryRequest
): Promise<FunctionaryOfZone> => {
	const response = await volunteerServiceClient.post<FunctionaryOfZone>(
		'getFunctionary',
		request
	);
	return response.data;
};

export const getZonesOfLoggedInPreworkFunctionary = async (
	request: GetZonesRequest
): Promise<GetZonesResponse> => {
	const response = await volunteerServiceClient.post<GetZonesResponse>(
		'getZonesOfLoggedInPreworkFunctionary',
		request
	);
	return response.data;
};

export const getZonesOfPreworkPreceptors = async (
	request: GetZonesRequest
): Promise<GetZonesResponse> => {
	const response = await volunteerServiceClient.post<GetZonesResponse>(
		'getZonesOfPreworkPreceptors',
		request
	);
	return response.data;
};

export const getPreworkApplications = async (
	request: PreworkApplicationsRequest
): Promise<PreworkApplicationsResponse> => {
	const response =
		await volunteerServiceClient.post<PreworkApplicationsResponse>(
			'getPreworkApplications',
			request
		);
	return response.data;
};

export const capturePreworkMentorAnswers = async (
	request: PreworkMentorAnswersRequest
): Promise<BooleanValue> => {
	const response = await volunteerServiceClient.post<BooleanValue>(
		'capturePreworkMentorAnswers',
		request
	);
	return response.data;
};

export const getPreworkZones = async (
	request: GetZonesRequest
): Promise<GetZonesResponse> => {
	const response = await volunteerServiceClient.post<GetZonesResponse>(
		'getPreworkZones',
		request
	);
	return response.data;
};

export const submitApproverPreworkRecommendation = async (
	request: PreworkRecommendationRequest
): Promise<BooleanValue> => {
	const response = await volunteerServiceClient.post<BooleanValue>(
		'submitApproverPreworkRecommendation',
		request
	);
	return response.data;
};
